module.exports = __webpack_public_path__ + "assets/img/enginio_info_card_allt_du_vill_veta.114f9e8d.png";